export const en = {
    format: 'Format',
    operatorName: 'Operator',
    selected: 'Selected'
};
